module.exports = __webpack_public_path__ + "static/media/card2_7.b128ce05.png";